import PeriodValueFormulaNode from "./PeriodValueFormulaNode.js";

/**
 * `closingBalanceFormulaNode` is a concrete implementation of `periodValueFormulaNode`
 * representing a closing balance node.
 */
export default class ClosingBalanceFormulaNode extends PeriodValueFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitClosingBalanceNode(this, additionalInformation);
	}

	static getType() {
		return "ClosingBalanceNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildPeriodValueNode(this, additionalInformation);
	}
}
